import { useState } from "react";
import { useLoyalty } from "../../../../hooks";
import axios from "axios";

const { REACT_APP_SERVER_URL: SERVER_URL } = process.env;
const BASE_URL = `${SERVER_URL}/survey-feedback`;

const useSurvey = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const token = JSON.parse(localStorage.getItem("token"));
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Token ${token}`,
  };

  const submitSurvey = async (interactionID, surveyCode, feedback) => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.post(
        BASE_URL,
        {
          interactionID,
          surveyCode,
          response: feedback,
        },
        { headers }
      );

      return response.data;
    } catch (err) {
      console.error("Error submitting survey:", err);
      setError("Failed to submit the survey. Please try again.");
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    submitSurvey,
    loading,
    error,
  };
};

export default useSurvey;
